import * as React from 'react';
import '@styles/pages/tab4.scss';
import rule41back from '@images/rule41back.png';
import rule42back from '@images/rule42back.png';
import rule44back from '@images/rule44back.png';
import rule45back from '@images/rule45back.png';
import rule436back from '@images/rule436back.png';
const {useState} = React;
interface TabsType {
  current: number,
  title: string,
}
const tabs: TabsType[] = [
  {
    current: 0,
    title: '活动赛程',
  },
  {
    current: 1,
    title: '奖励',
  },
]
const Images = ['rule41back', 'rule42back', 'rule44back', 'rule45back', 'rule436back'].map((item: string) => require(`./../../assets/images/${item}.png`));
const images = [];
for (let i = 0; i < Images.length; i++) {
  images[i] = new Image();
  images[i].src = Images[i].default;
}
const imgs = [
  [
    'https://diy-assets.msstatic.com/2008fans/rule1.png?' + (new Date()).valueOf(),
    'https://diy-assets.msstatic.com/2008fans/rule2.png?' + (new Date()).valueOf(),
  ],
  [
    'https://diy-assets.msstatic.com/2008fans/rule3.png?' + (new Date()).valueOf(),
    [
      {
        back: rule41back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule41.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1609,
      },
      {
        back: rule41back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule42.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1609,
      },
      {
        back: rule436back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule43.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1999,
      },
      {
        back: rule44back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule44.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1812,
      },
      {
        back: rule45back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule45.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1999,
      },
      {
        back: rule436back,
        value: 'https://diy-assets.msstatic.com/2008fans/rule46.png?' + (new Date()).valueOf(),
        width: 1200,
        height: 1999,
      },
    ]
  ]
]
interface RuleTabs {
    title: string,
    tips: string,
}
const subTabs: RuleTabs[] = [
  {
    title: '王牌分区',
    tips: '手游/网游/单机/偶像/才艺',
  },
  {
    title: '新锐分区',
    tips: '新游/红人/星势力/颜值',
  },
  {
    title: '交友荣耀分区',
    tips: '',
  },
  {
    title: '交友星光分区',
    tips: '',
  },
  {
    title: '陪玩荣耀分区',
    tips: '',
  },
  {
    title: '陪玩星光分区',
    tips: '',
  },
]
const Tab4: React.FC<void> = () => {
  const [index, Index] = useState<number>(0);
  const [indexs, Indexs] = useState<number>(0);
  return (
    <div className='tab4'>
      <div className='tab4tab'>
        <div className='tabline'>
          {
            tabs.map((item: TabsType) => (
              <div
                className={index === item.current ? 'tab4item on' : 'tab4item'}
                key={item.current}
                onClick={
                  (): void => {
                    Index(item.current);
                  }
                }
              >
                <h2>{item.title}</h2>
                <i></i>
              </div>
            ))
          }
        </div>
      </div>
      {
        index === 0 &&
        <>
          <img src={imgs[index][0]} className='ruleimg' />
          <img src={imgs[index][1]} className='ruleimg'/>
        </>
      }
      {
        index === 1 &&
        <>
          <img src={imgs[index][0]} className='ruleimg'/>
          <div
            style={
              {
                width: imgs[index][1][indexs].width,
                height: imgs[index][1][indexs].height,
                background: `url(${imgs[index][1][indexs].back}) center center no-repeat`,
                backgroundSize: '100% 100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '30px 0px'
              }
            }
          >
            <ul
              className='rule4tab'
            >
              {
                subTabs.map((item: RuleTabs, indexTab: number) => (
                  <li
                    key={item.title}
                    className={indexTab === indexs ? 'on' : ''}
                    onClick={
                      (): void => {
                        Indexs(indexTab);
                      }
                    }
                  >
                    <h1>{item.title}</h1>
                    {
                      item.tips !== '' &&
                      <p>{item.tips}</p>
                    }
                  </li>
                ))
              }
            </ul>
            <img
              src={imgs[index][1][indexs].value}
              className='rule4tabs'
            />
          </div>
        </>
      }
    </div>
  )
}

export default Tab4;